// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataLinksCatalog = createAsyncThunk('appUsers/getAllDataLinksCatalog', async id => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/catalog/links/all',  { params: { id} })
  return response.data
})

export const getDataLinksCatlaog = createAsyncThunk('appUsers/getDataLinksCatlaog', async params => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/catalog/links/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addLinks = createAsyncThunk('appUsers/addLinks', async (link, { dispatch, getState }) => {
  await axios.post('https://apiv4dev2.opentlv.com/api/v3/catalog/addlinks', link, {})

  await dispatch(getDataLinksCatlaog(getState().catalogLinks.params))
  return link


})
export const deleteLink = createAsyncThunk('appUsers/deleteLink', async (id, { dispatch, getState }) => {
  console.log("getState()")
  console.log(id)

  await axios.delete('https://apiv4dev2.opentlv.com/api/v3/catalog/media/delete', {params: {id}})
//  await dispatch(getData(getState().users.params))
await dispatch(getDataMediasCatlaog(getState().catalogMedias.params))

  return id
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataLinksCatalog.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataLinksCatlaog.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
